export default __webpack_public_path__ + "static/media/banner3.87f6dcd3.jpg";